import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, BookOpen, Star, User } from "lucide-react";
import { usePlayerAuth } from "../context/PlayerAuthContext";

const SHOW_PREFIXES = ["/hub", "/read", "/roadmap", "/profile"];

export const BottomTabBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { hasAccess } = usePlayerAuth();

  const visible = SHOW_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  if (!hasAccess || !visible) return null;

  const lastChapter = localStorage.getItem("nexto_last_chapter") || "philosophy";
  const tabs = [
    { key: "hub", label: "Hub", icon: Home, to: "/hub", active: pathname === "/hub" },
    { key: "ebook", label: "Blueprint", icon: BookOpen, to: `/read/${lastChapter}`, active: pathname.startsWith("/read") },
    { key: "roadmap", label: "Roadmap", icon: Star, to: "/roadmap", active: pathname === "/roadmap" },
    { key: "profile", label: "Profile", icon: User, to: "/profile", active: pathname === "/profile" },
  ];

  return (
    <nav
      data-testid="bottom-tab-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 backdrop-blur-xl bg-[#0d0d0d]/90 border-t border-white/10 shadow-[0_-8px_32px_rgba(0,0,0,0.55)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="grid grid-cols-4">
        {tabs.map((t) => {
          const Icon = t.icon;
          return (
            <button
              key={t.key}
              data-testid={`tab-${t.key}`}
              onClick={() => navigate(t.to)}
              className={`relative flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] transition-colors active:scale-95 ${t.active ? "bg-[#D4AF37]/10" : ""}`}
              style={{ color: t.active ? "#D4AF37" : "rgba(255,255,255,0.45)" }}
              aria-label={t.label}
            >
              {t.active && (
                <span
                  className="absolute top-0 h-0.5 w-10 rounded-full"
                  style={{ background: "#D4AF37", boxShadow: "0 0 12px rgba(212,175,55,0.8)" }}
                />
              )}
              <Icon size={20} strokeWidth={t.active ? 2.5 : 2} />
              <span className="text-[10px] font-bold uppercase tracking-wider">{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabBar;
